import { render, staticRenderFns } from "./TableMundialPlayOff.vue?vue&type=template&id=5c5d3f04&scoped=true&"
import script from "./TableMundialPlayOff.vue?vue&type=script&lang=js&"
export * from "./TableMundialPlayOff.vue?vue&type=script&lang=js&"
import style0 from "./TableMundialPlayOff.vue?vue&type=style&index=0&id=5c5d3f04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5d3f04",
  null
  
)

export default component.exports